import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth/authRoles';

import AccountCreatedResultPage from './AccountCreatedResultPage';

const AccountCreatedResultRoute: FuseRouteItemType = {
  path: 'account-created',
  element: <AccountCreatedResultPage />,
  auth: AUTH_ROLES.parent, // []
};

export default AccountCreatedResultRoute;
